<template>
  <div class="picture_album">
    <div class="context">
      <van-list offset="300" v-model="loading" :finished="finished" @load="search()">
        <div class="item" v-for="(item, index) in itemNumber" :key="index">
          <div
            class="inside_item"
            v-for="(it, ind) in dataList[index]"
            :key="ind"
            @click="clickItem(it)"
          >
            <img v-if="it.phoneImagePath" class="img" :src="it.phoneImagePath" alt="" />
          </div>
          <div class="layer">
            <img src="../../../static/image/小层.png" alt="" />
          </div>
        </div>
      </van-list>

      <div class="item" v-if="itemNumber == 0">
        <div class="inside_item">
          <!-- <img class="img" alt="" /> -->
        </div>
        <div class="layer">
          <img src="../../../static/image/小层.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const defaultQuery = Object.freeze({
  pageNum: 1,
  pageSize: 10,
  orders: '', // 排序1->升序;2->降序
  pictureAlbumName: '',
  language: sessionStorage.getItem('lang')
})
import { listPage } from '@/api/pictureAlbum'
export default {
  components: {},
  data() {
    return {
      query: { ...defaultQuery },
      dataList: [],
      itemNumber: 0,
      finished: false,
      loading: false,
      dataListTwo: []
    }
  },
  computed: {},
  watch: {},
  created() {
    this.search()
  },
  methods: {
    clickItem(item) {
      // console.log(item)
      // albumLink
      if (item.albumLink) {
        window.open(item.albumLink, '_blank')
      }
    },
    async search() {
      this.loading = true
      const { data: res } = await listPage(this.query)
      if (res.resultCode == 200) {
        let arrData = []
        this.dataListTwo = [...this.dataListTwo, ...res.data.list]
        arrData = this.dataListTwo

        if (arrData.length != 0) {
          this.itemNumber = Math.ceil(arrData.length / 3)
          const arr = []
          for (let index = 0; index < this.itemNumber; index++) {
            // console.log("触发了")
            let sss = (index + 1) * 3
            if (sss > arrData.length) {
              sss = arrData.length
            }
            arr.push(arrData.slice(index * 3, sss))
          }

          this.dataList = arr

          this.dataList.forEach((item, index) => {
            if (item.length == 1) {
              this.dataList[index].push('')
              this.dataList[index].push('')
            } else if (item.length == 2) {
              this.dataList[index].push('')
            }
          })
        }

        this.loading = false
        if (res.data.hasNextPage) {
          this.query.pageNum++
        } else {
          this.finished = true
        }
      }
    }
  },

  mounted() {
    let main = document.getElementsByClassName('picture_album')[0]
    let sub = main.nextSibling
    sub.style = 'margin: 0;'
  }
}
</script>
<style scoped lang="less">
.picture_album {
  height: 100vh;
  padding: 11px;
  background-image: url('../../../static/image/书架-背景.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;

  .context {
    .item {
      width: 100%;
      height: 135px;
      margin-bottom: 42px;
      position: relative;
      display: flex;
      justify-content: space-evenly;
      align-items: flex-end;

      .layer {
        position: absolute;
        width: 100%;
        height: 42px;
        bottom: 0;
        transform: translateY(100%);

        img {
          width: 100%;
          height: 100%;
        }
      }

      .inside_item {
        width: 88px;
        height: 124px;
        // background-color: rgba(255, 0, 0, 0.2);
        .img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
        }
      }
    }
  }
}
</style>
